import { proxy } from 'valtio';
export const priceDiffStore = proxy({
    max: NaN,
    min: NaN,
});
